/* eslint-disable camelcase */
import axios from 'axios';
import hookup from "./Hookup";
// import { decode } from './Utils';

const url = process.env.REACT_APP_API_URL;

// axios.interceptors.request.use((config) => {
//     const tokenSession = localStorage.getItem('t');

//     if(config.url.includes('oauth/newtoken')){
//         config.headers['Content-Type'] = 'application/x-www-form-urlencoded'
//     }
    
//     if (tokenSession) {
//         const token = decode(tokenSession);
//         // eslint-disable-next-line no-param-reassign
//         config.headers.Authorization = `Bearer ${token}`;
//     }

//     return config;
// }, (err) => Promise.reject(err));

// GENERAL

export const login = async (data:any) => {
    return await hookup("post", "oauth/newtoken", data);
};
export const amountNotWithDrawn = async (data:any) => {
    return await hookup("get", "auth/pagos/retirar", data);
};
export const accountResume = async (data:any) => {
    return await hookup("get", "auth/resumen/trimestral", data);
};
export const accountResumeAnual = async (data:any) => {
    return await hookup("get", "auth/resumen/anual", data);
};
export const dutyDetail = async (data:any) => {
    return await hookup("get", "auth/aranceles/search", data);
};
export const viewDocument = async (data:any) => {
    return await hookup("get", "auth/docelectronico/document", data);
};

export const getNewsPublic = async (data:any) => {
    return await hookup("get", "noticias", data);
};
export const getNewsPublicDetail = async (data:any) => {
    return await hookup("get", "noticias/"+data, {});
};

export const sendEmailContact = async (data:any) => {
    return await hookup("post", "auth/contactanos/enviar", data);
};
export const sendEmailWriteUs = async (data:any) => {
    return await hookup("post", "escribenos/enviar", data);
};
export const accountMedicalTeam = async (data:any) => {
    return await hookup("get", "auth/equipomedico/search", data);
};
export const medicalTeamDetail = async (data:any) => {
    return await hookup("get", "auth/equipomedico/detail", data);
};
export const billsDetail = async (data:any) => {
    return await hookup("get", "auth/docelectronico/search", data);
};
export const mailBoxPAM = async (data:any) => {
    return await hookup("get", "auth/buzonpam/search", data);
};
export const mailBoxPAMDetail = async (data:any) => {
    return await hookup("get", "auth/buzonpam/detail", data);
};


export const paymentDetail = async (data:any) => {
    return await hookup("get", "auth/detallepagos/search", data);
};
export const getDetailCargoAbono = async (data:any) => {
    return await hookup("get", "auth/detallepagos/cargoabonos/search", data);
};
export const getDetailPagoConsulta = async (data:any) => {
    return await hookup("get", "auth/detallepagos/resumen/pago", data);
};
export const getDetailPagoConsultaHQM = async (data:any) => {
    return await hookup("get", "auth/detallepagos/listado/hmq", data);
};
export const getDetailListadoPagoConsulta = async (data:any) => {
    return await hookup("get", "auth/detallepagos/listado/consultas", data);
};

export const getDetailConsulta = async (data:any) => {
    return await hookup("get", "auth/detallepagos/initial", data);
};
export const getDetailConsultaSearch = async (data:any) => {
    return await hookup("get", "auth/detallepagos/search", data);
};
export const getPostHome = async (data:any) => {
    return await hookup("get", "auth/home/posts", data);
};
export const getPaymentDates = async (data:any) => {
    return await hookup("get", "auth/home/paymentdates", data);
};
export const postValidarCelular = async (data:any) => {
    return await hookup("post", "auth/documentos/validar-celular", data);
};
export const postValidarCodigo = async (data:any) => {
    return await hookup("post", "auth/documentos/validar-codigo", data);
}
export const postValidarPassword = async (data:any) => {
    return await hookup("post", "auth/documentos/validar-password", data);
}
export const postGenerarCodigoFirma = async (data:any) => {
    return await hookup("post", "auth/documentos/generar-codigo-firma", data);
}
export const postVerificarCodigoFirmar = async (data:any) => {
    return await hookup("post", "auth/documentos/verificar-codigo-firmar", data);
}
export const postGenerarCertificado = async (data:any) => {
    return await hookup("post", "auth/documentos/generar-certificado", data);
}
export const getDocuments = async (data:any) => {
    return await hookup("get", "auth/documentos", data);
};
export const getImagesBanner = async (data:any) => {
    return await hookup("get", "auth/home/imagesbanner", data);
};
export const getAmsmConecta = async (data:any) => {
    return await hookup("get", "auth/home/amsmconecta", data);
};
export const getAmsmNewsLetter = async (data:any) => {
    return await hookup("get", "auth/home/newsletter", data);
};
export const getNewsletterFederacion = async (data:any) => {
    return await hookup("get", "auth/home/newsletter_federacion", data);
};
export const getEvents = async (data:any) => {
    return await hookup("get", "auth/home/events", data);
};
export const getLastBirthdays = async (data:any) => {
    return await hookup("post", "auth/last_birthdays", data);
};
export const getPostNews = async (data:any) => {
    return await hookup("get", "auth/home/posts/"+data, {});
};
export const getAmountHome = async (data:any) => {
    return await hookup("get", "auth/home/amount", data);
};
export const getAccountDetail = async (data:any) => {
    return await hookup("get", "auth/detallecuentapam/search", data);
};
export const getPrestacionSelected = async (data:any) => {
    return await hookup("get", "auth/detallecuentapam/filtros/prestacion", data);
};
export const getRutProfesionales = async (data:any) => {
    return await hookup("post", "rutProfesionales", data);
};
export const searchLyra = async (data:any) => {
    return await hookup("get", "auth/visits", data);
};

export const excelEquipoMedico = async (data:any) => {
    return await hookup("get", "auth/equipomedico/excel", data);
};

export const excelPaymentDetail = async (data:any) => {
    return await hookup("get", "auth/detallepagos/excel", data);
};

export const excelAccountDetail = async (data:any) => {
    return await hookup("get", "auth/detallecuentapam/excel", data);
};

export const graficoIntervenciones = async (data:any) => {
    return await hookup("get", "auth/detallepagos/grafico_intervenciones", data);
};
export const graficoIntervencionesPayments = async (data:any) => {
    return await hookup("get", "auth/detallepagos/grafico_pagos", data);
};

export const getPDFPago = async (data:any) => {
    return await hookup("get", "auth/detallepagos/reportePDF", data);
};

export const getGraficHome = async (data:any) => {
    return await hookup("get", "auth/home/grafico", data);
};

export const getFirmantes = async (token:string | undefined) => {
    return await hookup("get", `firmantes/${token}`, {});
};


//eliminar
export async function _login(data:any) {
    return axios.post(`${url}/auth`, { ...data });
}



export async function logout() {
    return axios.post(`${url}/logout`);
}

export async function recover(email:any) {
    return axios.post(`${url}/password`, { email });
}

export async function restore(data:any) {
    return axios.post(`${url}/reset`, { ...data });
}

// USERS

export async function getUsers() {
    return axios.get(`${url}/users`);
}

export async function addUser(data:any) {
    return axios.post(`${url}/users`, { ...data });
}

export async function updateUser(data:any, id:any) {
    return axios.put(`${url}/users/${id}`, { ...data });
}

export async function deleteUser(id:any) {
    return axios.delete(`${url}/users/${id}`);
}

export async function restoreUser(id:any) {
    return axios.get(`${url}/users/recovery/${id}`);
}

// CLIENTS

export async function getClients() {
    return axios.get(`${url}/clients`);
}

export async function getConstructionsByClient(id:any) {
    return axios.get(`${url}/clients/${id}/constructions`);
}

export async function addClient(data:any) {
    return axios.post(`${url}/clients`, { ...data });
}

export async function updateClient(data:any, id:any) {
    return axios.put(`${url}/clients/${id}`, { ...data });
}

export async function deleteClient(id:any) {
    return axios.delete(`${url}/clients/${id}`);
}

// MACHINE

export async function getMachines() {
    return axios.get(`${url}/machine`);
}

export async function getMachine(id:any) {
    return axios.get(`${url}/machine/${id}`);
}

export async function addMachine(data:any) {
    return axios.post(`${url}/machine`, { ...data });
}

export async function updateMachine(data:any, id:any) {
    return axios.put(`${url}/machine/${id}`, { ...data });
}

export async function deleteMachine(id:any) {
    return axios.delete(`${url}/machine/${id}`);
}

// CONSTRUCTIONS

export async function getConstructions() {
    return axios.get(`${url}/construction`);
}

export async function addConstruction(data:any) {
    return axios.post(`${url}/construction`, { ...data });
}

export async function updateConstruction(data:any, id:any) {
    return axios.put(`${url}/construction/${id}`, { ...data });
}

export async function deleteConstruction(id:any) {
    return axios.delete(`${url}/construction/${id}`);
}

// FORMS

export async function getForms() {
    return axios.get(`${url}/model-form`);
}

export async function getFormsAttached(id:any) {
    return axios.get(`${url}/model-form/customer/${id}`);
}

export async function getFormsDraft() {
    return axios.get(`${url}/model-form/draft`);
}

export async function getForm(id:any) {
    return axios.get(`${url}/model-form/${id}`);
}

export async function addForm(data:any) {
    return axios.post(`${url}/model-form`, { ...data });
}


export async function updateForm(data:any, id:any) {
    return axios.put(`${url}/model-form/${id}`, { ...data });
}

export async function deleteForm(id:any) {
    return axios.delete(`${url}/model-form/${id}`);
}

export async function copyForm(form_id:any) {
    return axios.post(`${url}/model-form/copy/form`, { form_id });
}

export async function addSection(data:any, form_id:any) {
    return axios.post(`${url}/model-form/${form_id}/sections`, { ...data });
}

export async function updateSection(data:any, id:any) {
    return axios.put(`${url}/model-form/sections/${id}`, { ...data });
}

export async function orderSection(data:any, id:any) {
    return axios.patch(`${url}/model-form/order/section/${id}`, { ...data });
}

export async function deleteSection(id:any) {
    return axios.delete(`${url}/model-form/sections/${id}`);
}

export async function copySection(section_id:any) {
    return axios.post(`${url}/model-form/copy/section`, { section_id });
}

// FIELDS

export async function getFields(section_id:any) {
    return axios.get(`${url}/model-section/${section_id}`);
}

export async function addField(data:any, section_id:any) {
    return axios.post(`${url}/forms/model-section/${section_id}/fields`, { ...data });
}

export async function updateField(data:any, id:any) {
    return axios.patch(`${url}/forms/sections/fields/${id}`, { ...data });
}

export async function orderField(data:any, section_id:any) {
    return axios.patch(`${url}/forms/order/field/${section_id}`, { ...data });
}

export async function deleteField(id:any) {
    return axios.delete(`${url}/forms/sections/fields/${id}`);
}

export async function copyField(field_id:any) {
    return axios.post(`${url}/forms/copy/field`, { field_id });
}

// REGISTER

export async function sendRegister(data:any) {
    return axios.post(`${url}/register`, { ...data });
}

export async function getRegisters() {
    return axios.get(`${url}/register`);
}

export async function getRegistersDiff(id:any) {
    return axios.get(`${url}/register/diff/${id}`);
}


// VERSION

export async function versionUpdate(params:any) {
    return axios.post(`${url}/model-form/version/update`, params);
}


// INSTALLATIONS
export async function getInstallations() {
    return axios.get(`${url}/installation`);
}

export async function getInstallationsPhase(id:any) {
    return axios.get(`${url}/installation/phase/${id}`);
}

export async function getInstallationsForms() {
    return axios.get(`${url}/installation/forms`);
}

export async function getInstallationFormData() {
    return axios.get(`${url}/installation/data`);
}

export async function getFormAndClients(id:any) {
    return axios.get(`${url}/installation/form-client/${id}`);
}

export async function createInstallation(data:any) {
    return axios.post(`${url}/installation`, data);
}

export async function updateInstallation(id:any, data:any) {
    return axios.put(`${url}/installation/${id}`, data);
}

export async function deleteInstallation(id:any) {
    return axios.delete(`${url}/installation/${id}`);
}


// CUSTOMERS
export async function getCustomers() {
    return axios.get(`${url}/customers`);
}

export async function attachFormsToCustomer(data:any) {
    return axios.post(`${url}/customers/forms/sync`, { ...data });
}

export async function attachClientToCustomer(data:any) {
    return axios.post(`${url}/customers/client/sync`, { ...data });
}

// TECHNICALS
export async function getTechnicals() {
    return axios.get(`${url}/technicals`);
}

export async function attachCustomerToTechnical(data:any) {
    return axios.post(`${url}/technical/sync/customers`, { ...data });
}

// PHASES
export async function getPhases() {
    return axios.get(`${url}/phases`);
}

export async function createPhase(data:any) {
    return axios.post(`${url}/phases`, data);
}

export async function updatePhase(id:any, data:any) {
    return axios.put(`${url}/phases/${id}`, data);
}

export async function deletePhase(id:any) {
    return axios.delete(`${url}/phases/${id}`);
}


// REGISTERS

export async function createForm(data:any) {
    return axios.post(`${url}/form`, data);
}

// MARKETPLACE

export async function getProducts(params: any = {}) {
    return axios.get(`${url}/auth/products`, { params });
}

export async function addProduct(data:any) {
    return axios.post(`${url}/auth/products`, data);
}

export async function editProduct(id: number, data:any) {
    return axios.post(`${url}/auth/products/${id}`, data);
}

// SOLICITUDES

export async function rejectSolicitud(solicitudId: string, motivo: string) {
    return axios.post(`${url}/auth/solicitudes/${solicitudId}/reject`, { motivo });
}
